export default __webpack_public_path__ + "static/media/12.18.24 Minutes of the Regular Meeting of the BOD.9e996720.pdf";